import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export default function DialogDoublon({dialogData}) {

    return (<Dialog
        open={dialogData.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Attention
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Nom et prénom déjà existant.<br></br>
          Merci de contacter votre centre d’affectation.<br></br><br></br>
          Voulez-vous tout de même continuer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dialogData.resolve(false)}>Non</Button>
          <Button onClick={() => dialogData.resolve(true)} autoFocus>
            Oui
          </Button>
        </DialogActions>
      </Dialog>)
}